import { useFeature } from '@growthbook/growthbook-react';
import { useRef } from 'react';
import FEATURES from '../../constants/featureToggling';
import { useQueryCategories } from '../../hooks/API/useQueryCategories';
import { useRecentGames } from '../../hooks/useRecentGames';
import { useWindowSizes } from '../../hooks/useAvailableWindowSizes';
import useIsDesktopLayout from '../../hooks/useIsDesktopLayout';

export const useQueryDashboardData = (enabled = true) => {
  const queryCategories = useQueryCategories(
    {},
    {
      enabled: enabled,
    }
  );
  const categoryList = queryCategories.data?.items ?? [];

  return {
    ...queryCategories,
    categoryList,
  };
};

export const useGamesCountInWidget = (element) => {
  const { width: windowWidth } = useWindowSizes();
  const isDesktop = useIsDesktopLayout();
  const shouldUseThreeColumnsForGames = useFeature(
    FEATURES.USE_THREE_COLUMNS_FOR_GAMES
  ).on;
  const width = element ? element?.getBoundingClientRect()?.width : windowWidth;

  if (shouldUseThreeColumnsForGames && !isDesktop) {
    if (width < 500) {
      return 3;
    }
  }

  if (!isDesktop) {
    if (width < 500) {
      return 2;
    }

    if ((width >= 768 && width < 930) || width >= 1240) {
      return 4;
    }

    if (width < 768) {
      return 6;
    }

    if (width < 1280) {
      return 5;
    }
  }

  if (width < 1040) {
    return 4;
  }
  if (width < 1200) {
    return 5;
  }
  if (width < 1440) {
    return 6;
  }
  if (width < 1600) {
    return 7;
  }
  return 8;
};

export const useRecentGame = (queryOptions = {}) => {
  const defaultCollection = useRef({
    isLoading: false,
    recentGame: null,
    recentGameId: null,
    recentGameProviderId: null,
  });
  const queryGame = useRecentGames(queryOptions);
  const recentGame = queryGame?.data;

  if (recentGame) {
    const recentGameId = recentGame[0]?.id;
    const recentGameProviderId = recentGame[0]?.provider;

    return {
      isLoading: queryGame?.isLoading,
      recentGame,
      recentGameId,
      recentGameProviderId,
    };
  }

  return defaultCollection.current;
};
